import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { shipmentsApi } from '../../api/shipments-api';
import { shipmentStateLabels } from '../../domain/shipment';

/** A link to a shipment, named by its consignment number and state once it loads. */
export function ShipmentLink({ shipmentId }: { shipmentId: string }) {
  const shipment = useQuery({
    queryKey: ['shipment', shipmentId],
    queryFn: () => shipmentsApi.getShipment(shipmentId),
  });
  const label = shipment.data
    ? `${shipment.data.cargonizerConsignmentNumber || 'Shipment'} · ${shipmentStateLabels[shipment.data.state]}${shipment.data.delivery ? ' · Delivered' : ''}`
    : 'Shipment';
  return <Link to={`/shipments/${encodeURIComponent(shipmentId)}`}>{label}</Link>;
}
